import {type LastMileConfigResponseType} from "../Settings/settings";
import type { AnalyticsCfg} from './types-analytics';

export const getAnalyticsFilterFromLastmileFilter = function(lastmileConfig: LastMileConfigResponseType): AnalyticsCfg {
    let cfg = {
        dbname: 'jobs',
        data_category: '',
        column: lastmileConfig.filterColumns,
        group: lastmileConfig.filterGroups,
        clusters: lastmileConfig.clusters,
        fld: {},
        fld_order: [],
        related: []
    };
    for (let fld of lastmileConfig.availableTypes) {
        cfg.fld[fld.name] = JSON.parse(JSON.stringify(fld));
        for (let i in cfg.fld[fld.name]) {
            if (cfg.fld[fld.name][i] === null) {
                delete(cfg.fld[fld.name][i]);
            }
        }
        cfg.fld[fld.name].name_db = fld.name;
        cfg.fld[fld.name].label = fld.desc;
        cfg.fld[fld.name].fk = 0;
        cfg.fld[fld.name].filter = 1;
        cfg.fld[fld.name].colorable = 0;
        cfg.fld[fld.name].type_gm = '';
        cfg.fld_order.push(fld.name);
    }
    return cfg;
}